import { render, staticRenderFns } from "./profile-tabs.component.vue?vue&type=template&id=823ce43c&scoped=true&"
import script from "./profile-tabs.component.vue?vue&type=script&lang=ts&"
export * from "./profile-tabs.component.vue?vue&type=script&lang=ts&"
import style0 from "./profile-tabs.component.vue?vue&type=style&index=0&id=823ce43c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823ce43c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VTab,VTabItem,VTabs,VTabsItems})
